<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('detailOrAcceptCredit.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-form
            :model="baseData"
            :rules="baseDataRules"
            ref="baseForm"
            :disabled="$route.query.returnStatus != 1"
            label-width="120px"
          >
            <el-row>
              <!-- 公司代码 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.companyCode')"
                  prop="businessCompanyCode"
                >
                  <el-select
                    clearable
                    disabled
                    @change="changeCompany"
                    class="widthStyle"
                    v-model="baseData.businessCompanyCode"
                    filterable
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.companyPlaceholder')"
                  >
                    <el-option
                      v-for="(item, index) in companyOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 部门 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.departmentCode')"
                  prop="businessDepartmentCode"
                >
                  <el-select
                    clearable
                    class="widthStyle"
                    @change="changeDepartment"
                    v-model="baseData.businessDepartmentCode"
                    filterable
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.departmentPlaceholder')"
                  >
                    <el-option
                      v-for="(item, index) in departmentOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 信用证号 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clCode')"
                  prop="clCode"
                >
                  <el-input
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.clCodePlaceholder')"
                    v-model="baseData.clCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 信用证类别 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clType')"
                  prop="clType"
                >
                  <dict-select
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.clTypePlaceholder')"
                    type="cl-clType"
                    @input="changeClType"
                    v-model="baseData.clType"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 信用证金额 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clAmount')"
                  prop="clAmount"
                >
                  <input-number
                    v-model="baseData.clAmount"
                    :max="999999999999.999999"
                    :min="0"
                  ></input-number>
                </el-form-item>
              </el-col>
              <!-- 币别-->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.currencyCode')"
                  prop="currencyCode"
                >
                  <dict-select
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.currencyPlaceholder')"
                    type="all_currency"
                    @change="changeCurrency"
                    v-model="baseData.currencyCode"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 开证行 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.branchCode')"
                  prop="branchCode"
                >
                  <search-table
                    v-if="baseData.clType == '002'"
                    v-model="baseData.branchCode"
                    searchType="bank"
                    placeholder="请选择开证行"
                    :currentValue="baseData.branchName || null"
                    :checkRowKeys="[baseData.branchCode]"
                    @input="changeBank"
                    :isMultiple="true"
                  ></search-table>
                  <el-input
                    v-else
                    placeholder="请输入开证行"
                    @input="changeInputBank"
                    v-model="baseData.branchCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 付款行 -->
              <el-col :span="6">
                <el-form-item
                  disabled
                  :label="this.$t('detailOrAcceptCredit.baseForm.payBranchCode')"
                  prop="payBranchCode"
                >
                  <search-table
                    v-if="baseData.clType == '002'"
                    v-model="baseData.payBranchCode"
                    placeholder="请选择付款行"
                    searchType="bank"
                    :currentValue="baseData.payBranchName || null"
                    :checkRowKeys="[baseData.payBranchCode]"
                    @input="changePayBank"
                    :isMultiple="true"
                  ></search-table>
                  <el-input
                    v-else
                    placeholder="请输入付款行"
                    @input="changeInputBank"
                    v-model="baseData.payBranchCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 通知银行 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.notifyingBranchCode')"
                  prop="notifyingBranchCode"
                >
                  <search-table
                    v-if="baseData.clType == '002'"
                    v-model="baseData.notifyingBranchCode"
                    searchType="bank"
                    placeholder="请选择通知银行"
                    :currentValue="baseData.notifyingBranchName || null"
                    :checkRowKeys="[baseData.notifyingBranchCode]"
                    @input="changeNotifyingBank"
                    :isMultiple="true"
                  ></search-table>
                  <el-input
                    v-else
                    placeholder="请输入通知银行"
                    @input="changeInputBank"
                    v-model="baseData.notifyingBranchCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 议付行 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.negotiationBranchCode')"
                  prop="negotiationBranchCode"
                >
                  <search-table
                    v-if="baseData.clType == '002'"
                    v-model="baseData.negotiationBranchCode"
                    searchType="bank"
                    placeholder="请选择议付行"
                    :currentValue="baseData.negotiationBranchName || null"
                    :checkRowKeys="[baseData.negotiationBranchCode]"
                    @input="changeNegotiationBank"
                    :isMultiple="true"
                  ></search-table>
                  <el-input
                    v-else
                    @input="changeInputBank"
                    placeholder="请输入议付行"
                    v-model="baseData.negotiationBranchCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 信用证状态 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.statusFlag')"
                  prop="statusFlag"
                >
                  <dict-select
                    disabled
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.statusFlagPlaceholder')"
                    type="cl-recieve-statusFlag"
                    v-model="baseData.statusFlag"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 开证日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.issueDate')"
                  prop="issueDate"
                >
                  <el-date-picker
                    class="widthStyle"
                    v-model="baseData.issueDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.issueDatePlaceholder')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 收到信用证日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.receivingDate')"
                  prop="receivingDate"
                >
                  <el-date-picker
                    class="widthStyle"
                    v-model="baseData.receivingDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.receivingDatePlaceholder')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 信用证属性 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clAttr')"
                  prop="clAttr"
                >
                  <dict-select
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.clAttrPlaceholder')"
                    type="cl-clAttr"
                    v-model="baseData.clAttr"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 溢短装比例/% -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.overShortShippedPercentage')"
                  prop="overShortShippedPercentage"
                >
                  <el-input
                    :placeholder="
                      this.$t('detailOrAcceptCredit.baseForm.overShortShippedPercentagePlaceholder')
                    "
                    type="number"
                    v-model="baseData.overShortShippedPercentage"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 有效期限 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clValidDate')"
                  prop="clValidDate"
                >
                  <el-date-picker
                    class="widthStyle"
                    v-model="baseData.clValidDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.clValidDatePlaceholder')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 开证申请人 -->
              <el-col :span="6">
                <el-form-item
                  disabled
                  :label="this.$t('detailOrAcceptCredit.baseForm.partnerCode')"
                  prop="partnerCode"
                >
                  <search-table
                    v-model="baseData.partnerCode"
                    searchType="customer"
                    :currentValue="baseData.partnerName || null"
                    :checkRowKeys="[baseData.partnerCode]"
                    :extraData="{
                      companyCode: baseData.businessCompanyCode,
                      departmentCode: baseData.businessDepartmentCode,
                    }"
                    @input="setPartnerCode"
                    :isMultiple="true"
                  ></search-table>
                </el-form-item>
              </el-col>
              <!-- 信用证性质 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.clNature')"
                  prop="clNature"
                >
                  <dict-select
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.clNaturePlaceholder')"
                    type="cl-clNature"
                    v-model="baseData.clNature"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 远期天数 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.usanceDaysNumber')"
                  prop="usanceDaysNumber"
                >
                  <el-input
                    :placeholder="
                      this.$t('detailOrAcceptCredit.baseForm.usanceDaysNumberPlaceholder')
                    "
                    v-model="baseData.usanceDaysNumber"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 最迟装期 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.latestShipDate')"
                  prop="latestShipDate"
                >
                  <el-date-picker
                    class="widthStyle"
                    v-model="baseData.latestShipDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="
                      this.$t('detailOrAcceptCredit.baseForm.latestShipDatePlaceholder')
                    "
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 付款条件 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.payCondition')"
                  prop="payCondition"
                >
                  <dict-select
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.payConditionPlaceholder')"
                    type="receipt_condition"
                    v-model="baseData.payCondition"
                  >
                  </dict-select>
                </el-form-item>
              </el-col>
              <!-- 已承兑金额 -->
              <!-- <el-col :span="6">
          <el-form-item
            :label="this.$t('detailOrAcceptCredit.baseForm.acceptanceAmount')"
            prop="acceptanceAmount"
          >
            <el-input
              disabled
              :placeholder="this.$t('detailOrAcceptCredit.baseForm.acceptanceAmountPlaceholder')"
              v-model="baseData.acceptanceAmount"
            ></el-input>
          </el-form-item>
        </el-col> -->
              <!-- 已收款金额 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.paidAmount')"
                  prop="paidAmount"
                >
                  <el-input
                    disabled
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.paidAmountPlaceholder')"
                    v-model="baseData.paidAmount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 创建人 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.createBy')"
                  prop="createByName"
                >
                  <el-input
                    disabled
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.createByPlaceholder')"
                    v-model="baseData.createByName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 创建日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.gmtCreate')"
                  prop="gmtCreate"
                >
                  <el-date-picker
                    disabled
                    class="widthStyle"
                    v-model="baseData.gmtCreate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.gmtCreatePlaceholder')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 摘要 -->
              <el-col :span="24">
                <el-form-item
                  :label="this.$t('detailOrAcceptCredit.baseForm.summary')"
                  prop="summary"
                >
                  <el-input
                    v-model="baseData.summary"
                    :placeholder="this.$t('detailOrAcceptCredit.baseForm.summaryPlaceholder')"
                    type="textarea"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- <base-form
            name="1"
            ref="baseForm"
            @setTableData="setTableData"
            :type="$route.query.type"
          /> -->
        </div>
      </el-collapse-item>
      <el-tabs v-model="activeTab" class="addCooperationTabs" type="border-card">
        <!-- tab -->
        <el-tab-pane
          :key="item.name"
          v-for="item in tabPlanList"
          :label="item.label"
          :name="item.name"
        >
          <!-- 认领信息 -->
          <goods-table v-if="item.name == 'first'" ref="goodsTable" />
          <!-- 承兑信息 -->
          <accept-table v-else-if="item.name == 'second'" ref="acceptTable" />
          <!-- 议付信息 -->
          <delay-lock-exchangeRate-table
            v-else-if="item.name == 'three'"
            ref="delayLockExchangeRateTable"
            :baseData="baseData"
          />
          <!-- 押付信息 -->
          <delay-payment-table
            v-else-if="item.name == 'four'"
            ref="delayPaymentTable"
            :baseData="baseData"
          />
          <!-- 锁汇信息 -->
          <lock-exchangeRate-table
            v-else-if="item.name == 'five'"
            ref="lockExchangeRateTable"
            :baseData="baseData"
          />
        </el-tab-pane>
      </el-tabs>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 修改 -->
      <el-button type="primary" @click="edit()" :loading="load" class="fixed-bottom-btn">{{
        this.$t('applicationDetail.btnList.edit')
      }}</el-button>
      <!-- 保存 -->
      <el-button
        type="primary"
        @click="save('001')"
        :loading="load"
        :disabled="$route.query.returnStatus != 3"
        class="fixed-bottom-btn"
        >{{ this.$t('detailOrAcceptCredit.btnList.save') }}</el-button
      >
      <!-- 确认承兑 -->
      <!-- <el-button
        type="primary"
        @click="save('002')"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t("detailOrAcceptCredit.btnList.submit") }}</el-button
      > -->
      <!-- 撤销 -->
      <el-button
        type="primary"
        @click="revokeReceiveCreditLetter"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.revert') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import BaseForm from './components/baseForm'; // 基本信息
  import GoodsTable from './components/goodsTable'; // 合同信息
  import acceptTable from './components/acceptTable'; // 承兑信息
  import lockExchangeRateTable from './components/lockExchangeRateTable';
  import delayPaymentTable from './components/delayPaymentTable';
  import delayLockExchangeRateTable from './components/delayLockExchangeRateTable';
  import API from '@/api/capitalCenter/letterOfCredit';
  import { dateFormatter } from '@/common/js/util';
  import SearchTable from '@/components/form-item/search-table';
  import InputNumber from '@/components/form-item/input-number';
  import DictSelect from '@/components/DictSelect';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';

  export default {
    name: 'acceptCreditLC',
    components: {
      // BaseForm,
      GoodsTable,
      acceptTable,
      lockExchangeRateTable,
      delayPaymentTable,
      delayLockExchangeRateTable,
      SearchTable,
      InputNumber,
      DictSelect,
    },
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        baseData: {
          id: null,
          companyCode: null,
          companyName: null,
          departmentCode: null,
          departmentName: null,
          clCode: null,
          clAmount: null,
          companyCurrencyCode: null,
          companyCurrencyName: null,
          currencyCode: 'USD',
          currencyName: '美国 美元',
          branchCode: null,
          bankBranch: null,
          payBranchCode: null,
          payBranchName: null,
          notifyingBranchCode: null,
          notifyingBranchName: null,
          negotiationBranchCode: null,
          negotiationBranchName: null,
          statusFlag: '',
          issueDate: null,
          receivingDate: date,
          overShortShippedPercentage: 0,
          clValidDate: null,
          partnerCode: null,
          partnerName: null,
          usanceDaysNumber: 0,
          latestShipDate: null,
          acceptanceAmount: 0,
          paidAmount: 0,
          createBy: null,
          createByName: null,
          gmtCreate: null,
          summary: null,
          sourceType: 2,
        },
        bankOptions: [],
        departmentOptions: [],
        companyOptions: [],

        dictApi: '',
        clTypeData: {},
        currencyData: {},
        clAttrData: {},
        clNatureData: {},
        payConditionData: {},
        load: false,
        activeNames: ['1'],
        activeTab: 'second',
        clType: '001',
        componentsList: ['baseForm', 'goodsTable', 'acceptTable'],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      tabPlanList: function () {
        let arr = [{ label: '认领信息', name: 'first' }];
        if (this.clType == '001') {
          arr.push(
            { label: '议付信息', name: 'three' },
            { label: '押汇信息', name: 'four' },
            { label: '锁汇信息', name: 'five' }
          );
        } else if (this.clType == '002') {
          arr.push({ label: '承兑信息', name: 'second' });
        }
        return arr;
      },
      baseDataRules() {
        return {
          businessCompanyCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.companyPlaceholder'),
            },
          ],
          businessDepartmentCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.departmentPlaceholder'),
            },
          ],
          clCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.clCodePlaceholder'),
            },
          ],
          clType: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.clTypePlaceholder'),
            },
          ],
          clAmount: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.clAmountPlaceholder'),
            },
          ],
          currencyCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.currencyPlaceholder'),
            },
          ],
          branchCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.bankPlaceholder'),
            },
          ],
          payBranchCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.payBranchPlaceholder'),
            },
          ],
          notifyingBranchCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.notifyingBranchPlaceholder'),
            },
          ],
          issueDate: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.issueDatePlaceholder'),
            },
          ],
          receivingDate: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.receivingDatePlaceholder'),
            },
          ],
          overShortShippedPercentage: [
            {
              required: true,
              message: this.$t(
                'detailOrAcceptCredit.baseForm.overShortShippedPercentagePlaceholder'
              ),
            },
          ],
          clValidDate: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.clValidDatePlaceholder'),
            },
          ],
          partnerCode: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.partnerCodePlaceholder'),
            },
          ],
          clNature: [
            {
              required: true,
              message: this.$t('tFundCreditLetter.placeholder.clNature'),
            },
          ],
          usanceDaysNumber: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.usanceDaysNumberPlaceholder'),
            },
          ],
          latestShipDate: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.latestShipDatePlaceholder'),
            },
          ],
          acceptanceAmount: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.acceptanceAmountPlaceholder'),
            },
          ],
          paidAmount: [
            {
              required: true,
              message: this.$t('detailOrAcceptCredit.baseForm.paidAmountPlaceholder'),
            },
          ],
        };
      },
    },
    mounted() {
      this.clType = this.$route.query.clType ?? '001';
      if (this.clType == '001') {
        this.activeTab = 'three';
      } else {
        this.activeTab = 'second';
      }
      if (this.$route.query.id) {
        this.baseData.id = this.$route.query.id;
        this.getDetail(this.$route.query.id);
      } else {
        this.baseData.gmtCreate = dateFormatter(new Date());
        this.baseData.createBy = this.userInfo.userCode;
        this.baseData.createByName = this.userInfo.userName;
      }
      this.getCompany();
    },
    created() {},
    methods: {
      //切换币别
      changeCurrency(val) {
        console.log(val);
      },
      // 切换信用证类别
      changeClType() {
        this.baseData.branchCode = '';
        this.baseData.branchName = '';
        this.baseData.payBranchCode = '';
        this.baseData.payBranchName = '';
        this.baseData.notifyingBranchCode = '';
        this.baseData.notifyingBranchName = '';
        this.baseData.negotiationBranchCode = '';
        this.baseData.negotiationBranchName = '';
      },
      // 手工输入银行信息回调---国际证
      changeInputBank() {
        if (!this.baseData.clType) {
          this.$alert('请先选择信用证类型');
        }
      },
      // 切换开证行
      changeBank(val) {
        if (val) {
          this.baseData.branchCode = val[0]['branchCode'];
          this.baseData.branchName = val[0]['branchName'];
        } else {
          this.baseData.branchCode = '';
          this.baseData.branchName = '';
        }
      },
      // 切换付款行
      changePayBank(val) {
        if (val) {
          this.baseData.payBranchCode = val[0]['branchCode'];
          this.baseData.payBranchName = val[0]['branchName'];
        } else {
          this.baseData.payBranchCode = '';
          this.baseData.payBranchName = '';
        }
      },
      // 切换通知银行
      changeNotifyingBank(val) {
        if (val) {
          this.baseData.notifyingBranchCode = val[0]['branchCode'];
          this.baseData.notifyingBranchName = val[0]['branchName'];
        } else {
          this.baseData.notifyingBranchCode = '';
          this.baseData.notifyingBranchName = '';
        }
      },
      // 切换议付行
      changeNegotiationBank(val) {
        if (val) {
          this.baseData.negotiationBranchCode = val[0]['branchCode'];
          this.baseData.negotiationBranchName = val[0]['branchName'];
        } else {
          this.baseData.negotiationBranchCode = '';
          this.baseData.negotiationBranchName = '';
        }
      },
      async getDetail(id) {
        let baseData = {};
        const selectStatus = await this.$axios.post(API.QUERY_CREDITLETTER_BY_ID, { id: id });
        if (selectStatus.data.code == 0) {
          baseData = selectStatus.data.data;
          this.baseData = Object.assign({}, baseData);
          // this.$emit('setTableData', baseData);
          this.setTableData(baseData);
          this.initDepartment();
          // this.getDetailAcc(this.baseData.clCode);
        }
      },
      async getDetailAcc(clCode) {
        const selectStatus = await this.$axios.post(API.QUERY_CREDITLETTER_ACC_PAGE, {
          clCode: clCode,
        });
        if (selectStatus.data.code == 0) {
          let baseData = XEUtils.clone(this.baseData);
          baseData['acceptanceList'] = selectStatus.data.data;
          this.setTableData(baseData, 'acc');
        }
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyOptions = selectStatus.data.data;
        }
      },
      changeCompany(val) {
        this.departmentOptions = [];
        if (val) {
          this.baseData.businessCompanyName = this.companyOptions.find(
            (it) => it.value == val
          ).label;
          this.companyOptions.find((item) => {
            if (item.value === val) {
              this.initDepartment();
            }
          });
          this.$baseRequest.getLedger(val).then((res) => {
            if (res.length > 0) {
              //如果换公司，则币种都默认变化
              this.baseData.companyCurrencyCode = res[0].currencyCode;
              this.baseData.currencyCode = res[0].currencyCode;
            } else {
              //没有查询到公司账套
              this.baseData.companyCurrencyCode = null;
              this.baseData.currencyCode = null;
              this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
            }
          });
        } else {
          this.baseData.businessCompanyName = '';
        }
        this.resetParter();
        this.baseData.businessDepartmentCode = '';
        this.baseData.businessDepartmentName = '';
      },
      //业务部门
      initDepartment() {
        this.$axios
          .post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + this.baseData.businessCompanyCode)
          .then((res) => {
            if (0 == res.data.code) {
              this.departmentOptions = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      changeDepartment(val) {
        this.resetParter();
        if (val) {
          this.baseData.businessDepartmentName = this.departmentOptions.find(
            (it) => it.value == val
          ).label;
        } else {
          this.baseData.businessDepartmentName = '';
        }
        this.$forceUpdate();
      },
      // 设置受益人/合作伙伴
      setPartnerCode(row) {
        this.baseData.partnerCode = row[0].partnerCode;
        this.baseData.partnerName = row[0].partnerZhName;
      },
      // 重置受益人
      resetParter() {
        this.baseData.partnerCode = '';
        this.baseData.partnerName = '';
      },
      // 返回数据
      exportChildData(btnType) {
        this.baseData.statusFlag = btnType;
        if (btnType == '001' || btnType == '002') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
      // 点击修改/显示
      edit() {
        this.$route.query.returnStatus = this.$route.query.returnStatus == '3' ? '4' : '3';
        this.$route.query.isEdit = this.$route.query.isEdit == 'Y' ? 'N' : 'Y';
      },
      checkForm(item, resultArr, params) {
        const _self = this;
        var result = new Promise(function (resolve, reject) {
          // if (_self.$refs[item.outer]['0'].goodsData.length > 0) {
          _self.$refs[item.outer]['0'].exportChildData().then((res) => {
            if (res) {
              params = Object.assign(params, res);
              resolve();
            } else {
              reject();
            }
          });
          // } else {
          //   resolve();
          // }
        });
        resultArr.push(result);
        console.log(resultArr, 'resultArr');
      },
      save(btnType) {
        let params = { clCode: null, creditLetter: { id: null } };

        const _self = this;
        if (this.clType == '001') {
          if (
            this.$refs.delayLockExchangeRateTable['0'].goodsData.length <= 0 &&
            this.$refs.delayPaymentTable['0'].goodsData.length <= 0 &&
            this.$refs.lockExchangeRateTable['0'].goodsData.length <= 0
          ) {
            return this.$message.warning('请填写数据！');
          }
          let formArr = [
            { outer: 'delayLockExchangeRateTable', inner: 'goodsTable' },
            { outer: 'delayPaymentTable', inner: 'goodsTable' },
            { outer: 'lockExchangeRateTable', inner: 'goodsTable' },
          ];
          let resultArr = []; //用来接受返回结果的数组

          formArr.forEach((item) => {
            this.checkForm(item, resultArr, params);
          });
          Promise.all(resultArr)
            .then(() => {
              console.log('1111', params);
              _self.saveData(btnType, params);
            })
            .catch(function () {});
        } else {
          console.log('this.$refs.acceptTable', this.$refs.acceptTable);
          this.$refs.acceptTable['0'].exportChildData(btnType).then((res) => {
            if (res) {
              params = Object.assign(params, res);
              this.saveData(btnType, params);
            }
          });
        }
      },
      saveData(btnType, params) {
        console.log('得到的数据u', params);
        params.clCode = this.baseData.clCode;
        params.id = this.baseData.id;
        params.creditLetter.id = this.baseData.id;
        if (
          params.creditLetter.isAccpetComplete == '1' &&
          !params.creditLetter.acceptCompleteDate
        ) {
          this.$message({
            showClose: true,
            message: '选择完全承兑需填写完全承兑日期！',
            type: 'error',
            duration: 8000,
          });
          return;
        }
        let paramsData = {
          clCode: this.baseData.clCode,
          creditLetter: {
            id: this.baseData.id,
          },
        };
        if (this.clType == '001') {
          paramsData.delDelayPayList = params.delDelayPayList; //押汇删除id
          paramsData.delDelayLockList = params.delDelayLockList; //锁汇删除id
          paramsData.delNegotiationList = params.delNegotiationList; //议付删除id
          paramsData.acceptanceList = [
            {
              clCode: params.clCode,
              creditLetter: params.creditLetter,
              creditLetterNegotiationList: params.creditLetterNegotiationList,
              delayPaymentList: params.delayPaymentList,
              creditLetterDelayLockList: params.creditLetterDelayLockList,
            },
          ];
        } else {
          paramsData = params;
        }
        let flag = this.checkTotal(params);
        if (!flag) return;
        this.loading.startLoading();
        // 保存提交
        this.$axios.post(API.SAVE_CREDITLETTER_ACC, paramsData).then((res) => {
          this.loading.endLoading();
          console.log('调用接口了');
          if (res.data.code == 0) {
            // this.$refs.baseForm.getDetail(this.$route.query.id);
            this.$message({
              showClose: true,
              message:
                btnType == '001'
                  ? this.$t('detailOrAcceptCredit.msg.saveSussess')
                  : this.$t('detailOrAcceptCredit.msg.submitSusscess'),
              type: 'success',
            });
            this.goBack();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },

      revokeReceiveCreditLetter() {
        this.$confirmAction('撤销数据？', '是否确认撤销').then(() => {
          this.loading.startLoading();
          let id = this.baseData.id;
          this.$axios.post(API.REVOKE_RECIVE_CREDITLETTER, { id: id }).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.goBack();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        });
      },
      // 校验金额
      checkTotal(params) {
        let flag = true;
        let msg = '';
        if (this.clType == '001') {
          let negotiation =
            params.creditLetterNegotiationList
              ?.map((k) => k['negotiationAmount'])
              .reduce((acc, cur) => {
                const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                return num;
              }, 0) ?? 0;
          console.log('negotiation', negotiation);
          let delayPay =
            params.delayPaymentList
              ?.map((k) => k['delayAmount'])
              .reduce((acc, cur) => {
                const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                return num;
              }, 0) ?? 0;
          console.log('delayAmount', delayPay);
          let lockExChange =
            params.lockExchangeRateList
              ?.map((k) => k['lockAmount'])
              .reduce((acc, cur) => {
                const num = this.$cal.calCommon(acc, cur, '+', 'amount');
                return num;
              }, 0) ?? 0;
          if (parseFloat(negotiation + delayPay) > parseFloat(this.baseData.clAmount - 0)) {
            flag = false;
            msg = '议付&押汇总金额不能超过收证金额！';
          } else if (parseFloat(lockExChange) > parseFloat(this.baseData.clAmount - 0)) {
            flag = false;
            msg = '锁汇总金额不能超过收证金额！';
          }
        } else {
          let acceptTotal = params.acceptanceList
            .map((k) => k['acceptAmount'])
            .reduce((acc, cur) => {
              const num = this.$cal.calCommon(acc, cur, '+', 'amount');
              return num;
            }, 0);
          //承兑金额不能超过收证金额*（1+溢短装比例）
          let totalLimit = this.$refs.acceptTable['0'].calTotalLimit(this.baseData.clAmount);
          if (parseFloat(acceptTotal) > parseFloat(totalLimit)) {
            flag = false;
            msg = '承兑金额不能超过收证金额及溢短装之和（' + totalLimit + '）！';
          }
        }

        if (!flag) {
          this.$message({
            showClose: true,
            message: msg,
            type: 'error',
            duration: 10000,
          });
        }
        return flag;
      },
      setTableData(baseData, flag) {
        if (flag == 'acc') {
          baseData.isAccpetComplete = baseData.isAccpetComplete == '1';
          baseData.isPayComplete = baseData.isPayComplete == '1';
          this.$refs.acceptTable['0'].getDetail(baseData);
        }
        this.$refs.goodsTable.goodsData = baseData.contractList;

        if (this.clType == '001') {
          this.$refs.delayLockExchangeRateTable['0'].getDetail(
            baseData.creditLetterNegotiationList
          );
          this.$refs.delayPaymentTable['0'].getDetail(baseData.creditLetterDelayPaymentList);
          this.$refs.lockExchangeRateTable['0'].getDetail(baseData.creditLetterDelayLockList);
          this.$refs.delayLockExchangeRateTable['0'].detail = baseData.fundCollectionOrderList;
          this.$refs.delayPaymentTable['0'].detail = baseData.fundCollectionOrderList;
          this.$refs.lockExchangeRateTable['0'].detail = baseData.fundCollectionOrderList;
        } else {
          this.$refs.acceptTable['0'].getDetail(baseData);
          this.$refs.acceptTable['0'].detail = baseData.fundCollectionOrderList;
        }
        this.$refs.goodsTable['0'].$refs.goodsTable.loadData(baseData.contractList);
      },

      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '信用证收证承兑',
            },
          },
          toPath: {
            path: '/letterOfCredit/searchReceiveCredit',
            name: 'searchReceiveCreditLC',
            meta: {
              keepAlive: false,
              title: '信用证收证查询',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .widthStyle {
    width: 100%;
  }
</style>
